/**
 * Gallery Selection Store - Artwork selection logic
 */


export function createGallerySelectionStore() {
  return {
    selectArtworks(artworks) {
      const core_store = Alpine.store('galleryCore');

      core_store.selected_artworks = artworks;
    },

    selectArtwork(artwork, position) {
      const core_store = Alpine.store('galleryCore');
      const variants_store = Alpine.store('galleryVariants');

      if (position < core_store.selected_artworks.length) {
        // Mark as dirty so reactive system updates image URLs
        core_store.markArtworkImageDirty?.(artwork.id);
        core_store.selected_artworks[position] = artwork;

        if (position === 2 && typeof core_store.setSavedThirdArtwork === 'function') {
          core_store.setSavedThirdArtwork(artwork ?? null);
        }

        if (!artwork.variants || artwork.variants.length === 0) {
          console.warn('Selected artwork has no variants:', artwork);
          return;
        }

        this.applyVariantSelectionToArtwork(artwork, position, core_store, variants_store);
      }
    },

    applyVariantSelectionToArtwork(artwork, position, core_store, variants_store) {
      if (core_store.variant_selection.locked) {
        variants_store.applyVariantToArtwork(artwork, position);
      } else {
        variants_store.applyPreviewVariantToArtwork(artwork, position);

        if (artwork.selected_variant) {
          core_store.preview_variants = core_store.preview_variants.filter(v =>
            v.product_id !== artwork.id
          );

          core_store.preview_variants.push({
            ...artwork.selected_variant,
            product_id: artwork.id
          });
        }
      }
    },

    canSelectArtwork(artwork, position) {
      const core_store = Alpine.store('galleryCore');

      if (position < 0 || position >= core_store.required_artwork_count) {
        return false;
      }

      if (!artwork.variants || artwork.variants.length === 0) {
        return false;
      }

      return true;
    },

    isArtworkSelected(artwork) {
      const core_store = Alpine.store('galleryCore');

      return core_store.selected_artworks.some(selected =>
        selected && selected.id === artwork.id
      );
    },

    getArtworkPosition(artwork) {
      const core_store = Alpine.store('galleryCore');

      return core_store.selected_artworks.findIndex(selected =>
        selected && selected.id === artwork.id
      );
    },

    replaceArtwork(artwork, position) {
      if (this.canSelectArtwork(artwork, position)) {
        this.selectArtwork(artwork, position);
        return true;
      }
      return false;
    },

    removeArtwork(position) {
      const core_store = Alpine.store('galleryCore');

      if (position >= 0 && position < core_store.selected_artworks.length) {
        const newArtworks = [...core_store.selected_artworks];
        newArtworks[position] = null;

        core_store.selected_artworks = newArtworks;

        return true;
      }
      return false;
    },

    clearSelection() {
      const core_store = Alpine.store('galleryCore');

      core_store.selected_artworks = [];

      if (typeof core_store.setSavedThirdArtwork === 'function') {
        core_store.setSavedThirdArtwork(undefined);
      }
    },

    getValidSelectedArtworks() {
      const core_store = Alpine.store('galleryCore');

      return core_store.selected_artworks.filter(artwork =>
        artwork && artwork.id
      );
    },

    isSelectionComplete() {
      const core_store = Alpine.store('galleryCore');

      return this.getValidSelectedArtworks().length >= core_store.required_artwork_count;
    },

    getNextAvailablePosition() {
      const core_store = Alpine.store('galleryCore');

      for (let i = 0; i < core_store.required_artwork_count; i++) {
        if (!core_store.selected_artworks[i]) {
          return i;
        }
      }
      return -1;
    },

    swapArtworks(position1, position2) {
      const core_store = Alpine.store('galleryCore');

      if (position1 >= 0 && position1 < core_store.selected_artworks.length &&
          position2 >= 0 && position2 < core_store.selected_artworks.length) {

        const temp = core_store.selected_artworks[position1];
        core_store.selected_artworks[position1] = core_store.selected_artworks[position2];
        core_store.selected_artworks[position2] = temp;

        if (typeof core_store.setSavedThirdArtwork === 'function' && core_store.selected_artworks.length > 2) {
          core_store.setSavedThirdArtwork(core_store.selected_artworks[2] ?? null);
        }

        return true;
      }
      return false;
    }
  };
}
